<template>
  <figure class="msg tripla">
    <p class="chat-message" :class="style['chat-message-media']">
      <span v-if="imagePresent" :class="style['media-image-wrap']">
        <img alt="Message image" class="media-image" :src="chat.message_rich.image" />
      </span>
      <span v-if="formatChatMessage" :class="style['media-text']" v-html="formatChatMessage"></span>
    </p>
    <figure-caption :chat="chat" :operator-name="operatorName" />
  </figure>
</template>

<script>
import { formatChatMessage, checkImage } from 'Utilities'
import FigureCaption from './FigureCaption.vue'
import style from './scss/_media_widget.scss'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'

export default {
  components: { FigureCaption },
  mixins: [chatWidgetMixin],
  data() {
    return {
      style,
      imagePresent: false
    }
  },
  computed: {
    formatChatMessage() {
      return formatChatMessage(this.chat.message_rich.message)
    }
  },
  created() {
    this.checkImage()
  },
  methods: {
    checkImage() {
      if (this.chat.message_rich.image) {
        checkImage(this.chat.message_rich.image, false, 'no image found')
          .then((success) => {
            this.imagePresent = true
          })
          .catch((fail) => {
            this.imagePresent = false
          })
      }
    }
  }
}
</script>
